module.exports = __webpack_public_path__ + "static/media/021-snowing.255706de.svg";